import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  maxWidth: theme.spacing(164),
  margin: '0 auto',
  padding: theme.spacing(14, 0),

  '& .CXSContent': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    alignItems: 'self-start',
    [theme.breakpoints.down('md')]: {
      maxWidth: 'unset',
    },
    '& .CESTitle': {
      [theme.breakpoints.down('lg')]: {
        maxWidth: theme.spacing(60),
      },
    },
  },
  '& .CESMainImg': {
    width: theme.spacing(66.625),
    borderRadius: theme.spacing(0.75),
    overflow: 'hidden',
    aspectRatio: '5 / 6',
    maxWidth: '100%',
    [theme.breakpoints.down('md')]: {
      // width: theme.spacing(39.75),
      width: 'calc(100% - 1.5rem)',
    },
  },
  '& .CESGridImgs': {
    position: 'relative',

    '& .CESSubImg': {
      position: 'absolute',
      zIndex: 1,
      width: theme.typography.pxToRem(304),
      aspectRatio: '1 / 1',
      right: theme.spacing(-2.5),
      bottom: theme.spacing(-3.75),
      borderRadius: theme.spacing(0.75),
      overflow: 'hidden',
      boxShadow: '0px 4px 48px 0px rgba(0, 0, 0, 0.25)',
      [theme.breakpoints.down('lg')]: {
        right: 0,
      },
      [theme.breakpoints.down('md')]: {
        position: 'relative',
        top: theme.spacing(-3.25),
        marginLeft: 'auto',
      },
    },
  },
}));

export default StyledBox;
